import {
  DOCUMENT_TYPES_FETCH_LOADING,
  DOCUMENT_TYPES_FETCH_SUCCESS,
  DOCUMENT_TYPES_FETCH_ERROR,
  RESET_RESULT,
  DOCUMENT_UPLOAD_LOADING,
  DOCUMENT_UPLOAD_SUCCESS,
  DOCUMENT_UPLOAD_ERROR,
  DOCUMENTS_FETCH_LOADING,
  DOCUMENTS_FETCH_SUCCESS,
  DOCUMENTS_FETCH_ERROR,
  DOCUMENT_DELETE_SUCCESS,
  DOCUMENT_DELETE_ERROR,
  USER_DOCUMENT_FETCH_LOADING,
  USER_DOCUMENT_FETCH_SUCCESS,
  USER_DOCUMENT_FETCH_ERROR,
  DOCUMENT_FILTER_LOADING,
  DOCUMENT_FILTER_SUCCESS,
  DOCUMENT_FILTER_ERROR,
  VIEW_DOCUMENT_SUCCESS,
  VIEW_DOCUMENT_ERROR,
  VIEW_DOCUMENT_LOADING,
} from "../types";

const initialState = {
  loading: false,
  page_loading: false,
  result: [],
  typesResult: [],
  documentData: [],
  userData: [],
  filteredData: [],
  docResult:"",
  error: "",
  docError:"",
  addDocumentError: "",
  addDocumentSuccess: false,
  documentDeleteMessage: "",
  documentUploadMessage: "",
};

const documentTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case DOCUMENT_TYPES_FETCH_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: "",
      };
    case DOCUMENT_TYPES_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        typesResult: action.payload,
      };
    case DOCUMENT_TYPES_FETCH_ERROR:
      return {
        ...state,
        loading: false,
        typesResult: [],
        error: action.payload,
      };
    case DOCUMENTS_FETCH_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: "",
      };
    case DOCUMENTS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        documentData: action.payload,
      };
    case DOCUMENTS_FETCH_ERROR:
      return {
        ...state,
        loading: false,
        documentData: [],
        error: action.payload,
      };
    case DOCUMENT_FILTER_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: "",
      };
    case DOCUMENT_FILTER_SUCCESS:
      return {
        ...state,
        loading: false,
        documentData: action.payload,
      };
    case DOCUMENT_FILTER_ERROR:
      return {
        ...state,
        loading: false,
        filteredData: [],
        error: action.payload,
      };
    case USER_DOCUMENT_FETCH_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: "",
      };
    case USER_DOCUMENT_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        userData: action.payload,
      };
    case USER_DOCUMENT_FETCH_ERROR:
      return {
        ...state,
        loading: false,
        userData: [],
        error: action.payload,
      };
    case DOCUMENT_UPLOAD_LOADING:
      return {
        ...state,
        loading: action.payload,
        addDocumentError: "",
        addDocumentSuccess: false,
      };
    case DOCUMENT_UPLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
        addDocumentSuccess: true,
      };
    case DOCUMENT_UPLOAD_ERROR:
      return {
        ...state,
        loading: false,
        result: [],
        addDocumentError: action.payload,
        addDocumentSuccess: false,
      };
    case DOCUMENT_DELETE_SUCCESS:
      return {
        ...state,
        documentDeleteMessage: action.payload,
      };
    case DOCUMENT_DELETE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case VIEW_DOCUMENT_LOADING:
      return{
        ...state,
        page_loading:action.payload
      }
    case VIEW_DOCUMENT_SUCCESS:
      return{
        ...state,
        docResult:action.payload,
        page_loading:false
      };
    case VIEW_DOCUMENT_ERROR:
      return{
        ...state,
        page_loading:false,
        docError:action.payload
      }
    case RESET_RESULT:
      return {
        ...state,
        loading: false,
        result: [],
        typesResult: [],
        userData: [],
        error: "",
        docError:"",
        docResult:"",
        addDocumentSuccess: false,
        addDocumentError: "",
        documentDeleteMessage: "",
      };
    default:
      return state;
  }
};
export default documentTypeReducer;
